import { Modal, Button } from 'react-bootstrap'
import Dropzone from 'react-dropzone-component'
import ReactDOMServer from 'react-dom/server'
import './filepicker.css'
import './dropzone.css'
import styles from './ImportModal.css'

class ImportModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showInformationDialog: false,
      errorDescription: '',
      file: null
    }
  }

  setShowModalDialog = () => {
    this.setState({showInformationDialog: true})
  }

  render () {
    let {showLoadingButton, onClickDownloadTemplate} = this.props
    let statusButton = showLoadingButton ? 'active' : ''
    let copyThis = this
    let componentConfig = {
      iconFiletypes: ['.csv'],
      showFiletypeIcon: true,
      postUrl: 'no-url',
      uploadMultiple: false
    }
    let djsConfig = {
      previewTemplate: ReactDOMServer.renderToStaticMarkup(
        <div className={styles['preview-import']}>
          <div className='dz-preview dz-file-preview'>
            <div className='dz-details'>
              <div className='dz-file-remove'>
                <a href='#' data-dz-remove>
                  <span className='glyphicon glyphicon-remove-sign' />
                </a>
              </div>
              <div className='dz-filename'><span data-dz-name /></div>
              <strong><div className='dz-size' data-dz-size /></strong>
              <div className='progress'>
                <div className='progress-bar progress-bar-success progress-bar-striped'
                  role='progressbar'
                  aria-valuenow='40' aria-valuemin='0' aria-valuemax='100' />
              </div>
              <img data-dz-thumbnail />
            </div>
          </div>
        </div>
      ),
      autoProcessQueue: false,
      acceptedFiles: '.csv',
      uploadMultiple: false,
      init: function () {
        this.on('addedfile', function (file) {
          if (copyThis.state.file) {
            this.removeFile(copyThis.state.file)
            copyThis.setState({file: null})
          }
          copyThis.setState({
            file,
            act: ImportModal.VALIDATING
          })
          copyThis.validationFile(file).then((resolve) => {
            copyThis.setState({file: file})
          }).catch((reject) => {
            copyThis.props.changeModalVisibility()
            copyThis.setState({showInformationDialog: true, errorDescription: 'Error : ' + reject})
          })
        })

        this.on('removedfile', function (file) {
          copyThis.setState({file: null})
        })

        this.on('error', function (file) {
          if (!file.accepted) {
            copyThis.setState({showInformationDialog: true, errorDescription: 'Error: Only allowed CSV files'})
            this.removeFile(file)
            copyThis.setState({file: null})
          }
        })
      }

    }

    return (
      <div>
        <Modal show={this.props.onShow} bsClass='modal-import- modal' backdrop>
          <Modal.Header>
            <Modal.Title> Import Customers</Modal.Title>
          </Modal.Header>
          <Modal.Body className='modal-body no-padding'>
            <div className='customer-body'>
              <div className='customer-scroll'>
                <div className='mk-col-right-box right-modal-customer'>
                  <div className={styles['description'] + ' text-left'}>
                    <a className='download-our-template' onClick={onClickDownloadTemplate}>Download Our Template</a> file and add your customer information to upload customers in bulk.
                    To optimize performance, we can only process 2500 items at a time.
                    If you have any questions on how to bulk import your customers, please send an email to support@mokapos.com.
                  </div>
                  { showLoadingButton
                    ? <div className='box-dropzone box-dropzone-when-upload'>
                      <h3>Uploading is in progress...</h3>
                    </div>
                    : <div className='box-dropzone'>
                      <Dropzone
                        className={styles['dropzone-area']}
                        config={componentConfig}
                        djsConfig={djsConfig}
                        >
                        <div className='dz-default dz-message' />
                      </Dropzone>
                    </div>
                  }
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className='pull-left' onClick={this._onClickBtnHide} disabled={showLoadingButton}>Cancel</Button>
            {showLoadingButton
              ? <button className={`btn btn-primary has-spinner pull-right ${statusButton}`} disabled={!this.state.file}>
                <span className='glyphicon glyphicon-repeat normal-right-spinner' />
                Upload
              </button>
              : <button className='btn btn-primary has-spinner pull-right' onClick={this._onClickBtnUpload} disabled={!this.state.file}>
                Upload
              </button>
            }
          </Modal.Footer>
        </Modal>

        <Modal bsClass='modal-import- modal' show={this.state.showInformationDialog}>
          <Modal.Header>
            <Modal.Title bsClass={styles['information-modal']} componentClass='div'>Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{this.state.errorDescription}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => {
              this.hideInformationDialog()
              this.props.changeModalVisibility()
            }}>Ok</Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  _onClickBtnUpload = () => {
    this.props.onUpload(this.state.file)
    this.setState({file: null})
  }
  _onClickBtnHide = () => {
    this.props.onHide()
    this.setState({file: null})
  }

  validationFile = (file) => {
    return new Promise((resolve, reject) => {
      const element = $('.progress')
      $(element).css('width', '0%').show()
      /* global FileReader */
      /* is a way for tell eslint that filereader is a global */
      let reader = new FileReader()
      let errorMessage = null
      reader.readAsText(file)
      reader.onload = function (event) {
        // HACK => because sometimes windows has different code in newline so we change windows new line into universal string newline
        let csv = event.target.result.replace(/\r/g, '\n').replace(/\n\n/g, '\n')
        let resultOBject = $.csv.toArrays(csv)
        let resultLength = resultOBject.length
        if (resultLength > 2501) {  // first line is table header. 2500 items is the limit
          errorMessage = 'Please upload less than 2500 items'
        } else if (resultLength === 1) {
          errorMessage = "Customer can't be empty."
        }
        const MAX_COUNTER = 25
        for (let i = 1; i <= MAX_COUNTER; i++) {
          setTimeout(() => {
            $(element).css('width', i * (100 / MAX_COUNTER) + '%')
            if (i === MAX_COUNTER) {
              if (errorMessage) {
                reject(errorMessage)
              } else {
                resolve(true)
              }
              $(element).css('width', '0%')
            }
          }, i * 100)
        }
      }
    })
  }

  hideInformationDialog = () => {
    this.setState({showInformationDialog: false, errorDescription: '', file: null})
  }
}

export default (ImportModal)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListNonLoyalty/importModal/importModal.js